import { createContext } from "react";

import type { FavoriteContextType } from "./favorite-provider.types";

const noop = () => {};
const asyncNoop = async () => {};

export const FavoriteProviderContext = createContext<FavoriteContextType>({
  isLoading: false,
  isLoadingMore: false,
  hasMore: false,
  loadMore: noop,
  activeTab: "cars",
  setActiveTab: noop,
  currentFavorites: [],
  requestRemove: noop,
  confirmRemoveId: null,
  cancelRemove: noop,
  confirmRemove: asyncNoop,
  removingId: null,
  lastRemoved: null,
  dismissToast: noop,
});
